// utils/formatDateAndTime.ts

export const formatDate = (dateAndTimeString: string, locale = 'en-GB') => {
    try{
        const date = new Date(dateAndTimeString);
        if (isNaN(date.getTime())) {
            return null; // Return null if the date is invalid
        }
        return date.toLocaleDateString(locale, {  day: '2-digit',month: 'long',year: 'numeric' });
    } catch (e) {
        
    }

};

// Function to format time from timestamp
export const formatTime = (dateAndTimeString: string, locale = 'en-GB') => {
    try{
        const date = new Date(dateAndTimeString);
        if (isNaN(date.getTime())) {
            return null; // Return null if the date is invalid
        }
        return date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', hour12: true}).toUpperCase();
    }catch (e) {
        
    }
};

export default { formatDate, formatTime };
